import { Table } from '@tanstack/react-table';
import { PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';

interface DataTableToolbarSelectionProps<TData> {
  className?: string;
  enableSelection?: boolean;
  table: Table<TData>;
}

export function DataTableToolbarSelection<TData>({
  children,
  className,
  enableSelection = true,
  table,
}: PropsWithChildren<DataTableToolbarSelectionProps<TData>>) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-3xl border-[1px] border-input bg-muted/20 px-4 py-3">
      {enableSelection && (
        <p className="text-s1 pl-3 text-muted-foreground">
          <span className="text-primary">{table.getFilteredSelectedRowModel().rows.length}</span> de{' '}
          <span className="text-primary">{table.getFilteredRowModel().rows.length}</span> registros
          seleccionados
        </p>
      )}
      <div className={cn('flex flex-wrap gap-2', className)}>{children}</div>
    </div>
  );
}
